














import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { IAsset } from '@shared/types/IAsset';
import { ILink } from '@shared/types/ILink';
import { BaseButton, BaseImage } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

export interface IMegaMenuCard {
  _uid: string;
  heading?: string;
  image?: IAsset;
  description?: string;
  button_link?: ILink;
  button_text?: string;
}

export default defineComponent({
  name: 'MegaMenuCard',
  components: { BaseImage, BaseButton },
  props: {
    image: {
      type: Object as PropType<IAsset>,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: () => '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_link: {
      type: Object as PropType<ILink>,
      default: () => null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_text: {
      type: String,
      default: () => 'Learn more',
    },
  },
  setup(props) {
    const imageSrc = computed(() =>
      getStoryblokImageURL(props.image.filename, { width: 290, height: 182 }),
    );
    const imageAlt = computed(() => props.image.alt);

    const hasLink = computed((): boolean => {
      return !!props.button_link?.cached_url;
    });

    return {
      imageSrc,
      imageAlt,
      hasLink,
      sanitizeLinkUrl,
    };
  },
});
